import React from 'react';
import { NavLink } from 'react-router-dom';
import './Pages/PagesCss/Footer.css';
import logo from './assets/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: "Tools",
      links: [
        { name: "BullCalc Tool", path: "/StockProfitCalculator" },
        { name: "Investo Tool", path: "/SIPCalculator" },
        { name: "Stoploss Tool", path: "/StopLossCalculator" },
        { name: "Taxify Tool", path: "/StockCapitalGainsCalculator" },
      ]
    },
    {
      title: "Navigation",
      links: [
        { name: "Home", path: "/" },
        { name: "About", path: "/About" },
        { name: "Contact", path: "/Contact" },
      ]
    },
    {
      title: "Legal",
      links: [
        { name: "Privacy Policy", path: "/PrivacyPolicy" },
        { name: "Terms of Service", path: "/TermsCondition" },
        { name: "Content Policy", path: "/ContentPolicy" },
        { name: "Disclaimer", path: "/Disclaimer" },
        { name: "Cookie Policy", path: "/CookiePolicy" },
        { name: "Sitemap", url: "/sitemap.xml", external: true },
      ]
    },
    {
      title: "Our Platforms",
      links: [
        { name: "D-TechStudios", url: "https://d-techstudios.com", external: true },
        { name: "CryptoMux", url: "https://cryptomux.com", external: true },
        { name: "CreditsIQ", url: "https://creditsiq.com", external: true },
        { name: "AfterTaxPay", url: "https://aftertaxpay.net", external: true },
        { name: "Font-Max", url: "https://font-max.com", external: true },
        { name: "Aipicks", url: "https://aipicks.org", external: true },
      ]
    },
  ];

  const socialLinks = [
    { name: "Twitter", icon: "fa-brands fa-x-twitter", url: "https://x.com/D_TechStudios" },
    { name: "LinkedIn", icon: "fa-brands fa-linkedin", url: "https://www.linkedin.com/company/d-tech-studios?trk=public_post_follow-view-profile" },
    { name: "FaceBook", icon: "fa-brands fa-facebook-f", url: "https://www.facebook.com/people/D-Tech-Studios/61556107977536/" },
    { name: "Instagram", icon: "fa-brands fa-instagram", url: "https://www.instagram.com/d_techstudios/" }
  ];

  const renderLink = (link, index) => {
    if (link.external) {
      return (
        <a
          key={index}
          href={link.url}
          className="footer-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {link.name}
        </a>
      );
    }
    
    return (
      <NavLink key={index} to={link.path} className="footer-link">
        {link.name}
      </NavLink>
    );
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Main Content */}
        <div className="footer-content">
          
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="brand-logo">
              <img src={logo} alt="NoobToBull" className="logo" />
              <span className="brand-name">NoobToBull</span>
            </div>
            <p className="brand-description">
              Tools and calculators designed to simplify investing and help you make smarter financial decisions.
            </p>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="social-link"
                  aria-label={social.name}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links Grid */}
          <div className="footer-links">
            {footerSections.map((section, index) => (
              <div key={index} className="link-group">
                <h4 className="group-title">{section.title}</h4>
                <div className="link-list">
                  {section.links.map((link, linkIndex) => (
                    <div key={linkIndex} className="link-item">
                      {renderLink(link, linkIndex)}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="copyright">
            © {currentYear} NoobToBull. All rights reserved.
          </div>
          <div className="legal-links">
            <NavLink to="/PrivacyPolicy" className="legal-link">Privacy Policy</NavLink>
            <span className="separator">|</span>
            <a href="/sitemap.xml" className="legal-link" target="_blank" rel="noopener noreferrer">Sitemap</a>
            <span className="separator">|</span>
            <NavLink to="/CookiePolicy" className="legal-link">Cookie Policy</NavLink>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;